import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormOpen from '../../forms/FormOpen.jsx';

const PageOpen = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({ url: `/api/core/users/opens/${_id}` });
    }
  }, [_id]);

  const breadcrumb = [
    { to: '../', children: 'Opens' },
  ];

  return _id === 'new' ? (
    <>
      <Header breadcrumb={breadcrumb}>New Open</Header>
      <FormOpen />
    </>
  ) : (
    <PageHttp res={res}>
      {(doc) => (
        <>
          <Header breadcrumb={breadcrumb}>Edit</Header>
          <FormOpen
            open={doc}
          />
        </>
      )}
    </PageHttp>
  );
};

export default PageOpen;
